
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tv-electronics-removal",
      function () {
        return require("private-next-pages/tv-electronics-removal/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tv-electronics-removal"])
      });
    }
  